const TRANSFER_API_URL = `${process.env.REACT_APP_BACKEND_URL}synctrack/transfer`;

/**
 * Trigger Autodesk Docs → SharePoint flow
 * Server reads ProjectId, FolderIds, SiteId, DriveId (and optional RootPath) from the flow config.
 *
 * @param {Object} syncFlow - flow row (must contain instanceId)
 * @param {Object} [opts]
 * @param {string} [opts.runType="Manual"] - e.g., "Manual" | "Scheduled"
 * @param {string} [opts.runStatusId] - UUID string if you track run status
 * @returns {Promise<any>}
 */
export const handleAutodeskDocsToSharePointFlow = async (syncFlow, opts = {}) => {
  try {
    const token = localStorage.getItem('token');
    const flowId = syncFlow?.instanceId;

    if (!flowId) throw new Error('Instance ID is required to run this flow.');

    const params = new URLSearchParams({ flowId });
    if (opts.runType) params.set('runType', opts.runType);
    if (opts.runStatusId) params.set('runStatusId', opts.runStatusId);

    const url = `${TRANSFER_API_URL}/autodesk-docs-to-sharepoint?${params.toString()}`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const text = await response.text().catch(() => '');
      throw new Error(`API Error ${response.status}: ${response.statusText} ${text}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error in Autodesk Docs → SharePoint flow:', error);
    throw error;
  }
};
